import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0002
 */
/**
 * Custom con funciones adicionales al Formulario
 **/
class CustomAsignarBarrasRelacionadas extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);

        this.traerBarras = this.traerBarras.bind(this);
        this.gridOptionsTbPrincipal = Object.assign({}, this.gridOptions);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptionsTbPrincipal['onSelectionChanged']           = this.onSelectionChanged;

        this.ocultarCampos = this.ocultarCampos.bind(this);

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.successDatosPrincipal = this.successDatosPrincipal.bind(this);
        this.arreglarDecimales = this.arreglarDecimales.bind(this);

        this.sucessGuardar = this.sucessGuardar.bind(this);
        this.asignarBarras = this.asignarBarras.bind(this);
        this.eliminarBarras = this.eliminarBarras.bind(this);
        this.successEliminar = this.successEliminar.bind(this);
        this.successManejarRespuesta = this.successManejarRespuesta.bind(this);
        this.traerNomreArchivo = this.traerNomreArchivo.bind(this);

        //imprimir

        this.isJson                         =this.isJson.bind(this);
        this.generarArchivoTxt                         =this.generarArchivoTxt.bind(this);
        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);
        this.procesar                         =this.procesar.bind(this);


        this.isJson = this.isJson.bind(this);

        this.nombre_archivo = 'barras_relacionadas';

        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.validarBarras = this.validarBarras.bind(this);
        this.sucessValidarBarras = this.sucessValidarBarras.bind(this);
        this.servicio = '';
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
    }

    initForm() {
        console.log('Formulario CustomAsignarBarrasRelacionadas,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('codigo_articulo').setOnChange((props) => {
            this.getField('nombre_articulo').setError(false,'');
            this.getField('contenido').setError(false,'');
            this.getField('barras').setError(false,'');
            this.getField('alias').setError(false,'');
            this.ocultarCampos();
        });

        this.getField("codigo_articulo_aux").setOnChange(()=>{
             if(this.getField('codigo_articulo_aux').getValue()!=='')
                this.traerBarras();
        });
        this.getField('bt_aceptar').setClick(()=>{
            this.validarBarras();
        });
        this.getField('bt_cancelar').setClick(()=>{
            this.getField('modal_agregar').handleClose();
        });

        this.getField("bt_agregar").setVisible(true);
        this.getField("bt_agregar").setClick(() => {
            if(this.getField('codigo_articulo').valid() && this.getField('contenido').valid()){
                this.getField('nombre_barras_agregar').setValue(this.getField('nombre_articulo').getValue());
                this.getField('cantidad').setValue(1);
                this.getField('modal_agregar').handleClickOpen();
            }else{
                this.alertGeneral.toggle(true,'Es necesario seleccionar un registro de la tabla.',"error");
            }
        });

        this.getField("bt_eliminar").setClick(() => {
            if(this.fila_seleccionada.length>0){
                this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
                this.getField('confirmModalCustom').setClickDialog(() => { this.eliminarBarras() });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
                this.getField('confirmModalCustom').toggle(true);
                
            }else{
                this.alertGeneral.toggle(true,'Es necesario seleccionar un registro de la tabla.',"error");
            }
        });


        this.getField("bt_imprimir").setClick(() => {
            if(this.fila_seleccionada.length>0){
                if(this.getField('select_impresora').valid()){
                    this.servicio='imprimir';
                    this.procesar();
                }else{
                    this.alertGeneral.toggle(true,'Es necesario seleccionar un formato.',"error");
                }
            }else{
                this.alertGeneral.toggle(true,'Es necesario seleccionar un registro de la tabla.',"error");
            }
        });


        this.getField("bt_imprimir_tiquetes").setClick(() => {
            if(this.fila_seleccionada.length>0){
                if(this.getField('select_impresora').valid()){
                    this.servicio='imprimir_tiquetes';
                    this.procesar();
                }else{
                    this.alertGeneral.toggle(true,'Es necesario seleccionar un formato.',"error");
                }
            }else{
                this.alertGeneral.toggle(true,'Es necesario seleccionar un registro de la tabla.',"error");
            }
        });

    }

    eliminarBarras(){
        this.mostrarMensajeGuardando();
        let datos = {
        datos: {
            id_barras :this.fila_seleccionada[0].id
        }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-asignarbarrasrelacionadas', operacion: '7', operacion_tipo: "eliminar" };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'DELETE',
            body: datos,
            success: this.successEliminar,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successEliminar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
          this.mostrarMensajeAdicional("Barras relacionadas eliminada con éxito.");
          this.traerBarras();
        }else{
          let respuesta=Object.values(data.data.errores);
          let keys=Object.keys(data.data.errores);
          this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
        }
    }

    validarBarras(){
        if(this.getField('codigo_articulo').valid() && 
        this.getField('barras_agregar').valid() &&
        this.getField('nombre_barras_agregar').valid() &&
        this.getField('cantidad').valid()){
            let datos={ datos: {
                barras:this.getField('barras_agregar').getValue(),
                codigo_articulo:this.getField('codigo_articulo').getValue()
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-asignarbarrasrelacionadas', operacion: '20', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessValidarBarras,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }
    }

    sucessValidarBarras(data){
        if(data.estado_p === 200){
            this.alertGeneral.toggle(true, 'Esta barra ya existe para el código consultado.', 'error');
        }else {
            this.asignarBarras();
        }
    }

    asignarBarras(){
        this.mostrarMensajeGuardando();
          let datos={ datos: {
            sucursal_ingreso:this.sucursal_ingreso,
            barras:this.getField('barras_agregar').getValue(),
            cantidad:this.getField('cantidad').getValue(),
            codigo_articulo:this.getField('codigo_articulo').getValue(), 
            nombre_barras_agregar:this.getField('nombre_barras_agregar').getValue(),
            
        }};
        this.generalFormatPmv = { tipo_servicio: 'inve-asignarbarrasrelacionadas', operacion: 'agregar', operacion_tipo: 'crear' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.sucessGuardar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
    }

    sucessGuardar(data) {
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            if(data.data.mensaje_mostrar!==undefined)
                this.mostrarMensajeAdicional(data.data.mensaje);
            else{
                this.getField('modal_agregar').handleClose();
                this.traerBarras();
            }
        }else {
          if(data.estado_p===404) {
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
          }
          else {
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
          }
        }
      }



    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-asignarbarrasrelacionadas', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            data.data.impresora_barras.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.valor;
                dataOp['text'] = item.valor;
                opciones.push(dataOp);
            });
            
            this.puertos=data.data.puertos;
            this.andina=data.data.andina;

            this.getField('select_impresora').setOptions(opciones);

        } else if (data.estado_p === 404) {
            let opciones = [{ 'text': 'Ninguno', 'value': '', 'campos_cambian': {} }];
            this.getField('select_impresora').setOptions(opciones);

            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    onSelectionChanged() {
        this.fila_seleccionada = this.gridOptionsTbPrincipal.api.getSelectedRows();
    }

    ocultarCampos() {
        this.fila_seleccionada=[];
        this.getField('rejilla').toggle(false);
        //this.getField('bt_agregar').setVisible(false);
        this.getField('bt_eliminar').setVisible(false);
        this.getField('bt_imprimir').setVisible(false);
        this.getField('bt_imprimir_tiquetes').setVisible(false);
    }



    traerBarras() {
        let errores = 0;
        this.ocultarCampos();
        this.getField('nombre_articulo').setError(false,'');
        this.getField('contenido').setError(false,'');
        this.getField('barras').setError(false,'');
        this.getField('alias').setError(false,'');

        if (!this.getField('codigo_articulo').valid() && !this.getField('contenido').valid())
            errores++;

        if (errores === 0) {
            let datos = {
                datos: {
                    codigo_articulo: this.getField("codigo_articulo").getValue(),
                }
            };
            this.mostrarMensajeGenerando();
            this.generalFormatPmv = { tipo_servicio: 'inve-asignarbarrasrelacionadas', operacion: '1_codigo', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successDatosPrincipal,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
        }
    }


    successDatosPrincipal(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.gridOptionsTbPrincipal['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('cantidad', { cellRenderer: (props) => { return '' + this.currencyFormatterGeneral(props.data.cantidad) }, type: 'rightAligned' });
            configCell.set('costo', { cellRenderer: (props) => { return '' + this.currencyFormatterGeneral(props.data.costo) }, type: 'rightAligned' });
            configCell.set('id', {cellRenderer:(props) => {return ""+props.data.bodega } , hide: true});
            this.getField('rejilla').initData(this.gridOptionsTbPrincipal, configCell);
            this.getField('rejilla').toggle(true);
            this.getField('bt_agregar').setVisible(true);
            this.getField('bt_eliminar').setVisible(true);
            this.getField('bt_imprimir').setVisible(true);
            this.getField('bt_imprimir_tiquetes').setVisible(true);
        } else {
            this.mostrarMensajeNoHayDatos();
        }
    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


    procesar() {
        this.getField('modal_stickers').handleClickOpen();
        this.getField('cantidad_imprimir').setVisible(false);
        this.getField('la_cantidad').setVisible(false);
        this.getField('fecha_vencimiento').setVisible(false);
        this.getField('fecha_fabricacion').setVisible(false);
        this.getField('lote').setVisible(false);
        this.getField('bt_cancelar_adicionales').setClick(()=>{
            this.getField('modal_stickers').handleClose();
        });
        if(this.servicio==='imprimir'){
            
            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                //grandezebra
                this.getField('cantidad_imprimir').setVisible(true);
                this.getField('bt_aceptar_adicionales').setClick(()=>{
                    if(this.getField('cantidad_imprimir').valid())
                        this.generarArchivoTxt();
                });

            }else{
                //imprimir1
                this.getField('cantidad_imprimir').setVisible(true);
                if(this.andina==='S'){
                    this.getField('fecha_vencimiento').setVisible(true);
                    this.getField('fecha_fabricacion').setVisible(true);
                    this.getField('lote').setVisible(true);
                    this.getField('bt_aceptar_adicionales').setClick(()=>{
                        if(this.getField('cantidad_imprimir').valid() &&
                        this.getField('fecha_vencimiento').valid() &&
                        this.getField('fecha_fabricacion').valid() &&
                        this.getField('lote').valid()){
                            this.generarArchivoTxt();
                        }
                    });
                }else{
                    this.getField('la_cantidad').setVisible(true);
                    this.getField('bt_aceptar_adicionales').setClick(()=>{
                        if(this.getField('cantidad_imprimir').valid() &&
                        this.getField('la_cantidad').valid()){
                            this.generarArchivoTxt();
                        }
                    });
                }
                
            }
        }else{
            //imprimir 2
            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                //zebra
                this.getField('cantidad_imprimir').setVisible(true);
                this.getField('bt_aceptar_adicionales').setClick(()=>{
                    if(this.getField('cantidad_imprimir').valid())
                        this.generarArchivoTxt();
                });
            }else{
                //imprimir2
                this.getField('cantidad_imprimir').setVisible(true);
                this.getField('la_cantidad').setVisible(true);
                this.getField('bt_aceptar_adicionales').setClick(()=>{
                    if(this.getField('cantidad_imprimir').valid() &&
                    this.getField('la_cantidad').valid()){
                        this.generarArchivoTxt();
                    }
                });
            }
        }
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarArchivoTxt() {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2={};
        if(this.servicio==='imprimir'){
            datos2 = {
                sucursal_ingreso: this.sucursal_ingreso,
                select_impresora: this.getField('select_impresora').getValue(),
                codigo_articulo: this.getField('codigo_articulo').getValue(),
                nombre_articulo:this.getField('nombre_articulo').getValue(),
                barras:this.fila_seleccionada[0].barras,
                alias:this.getField('alias').getValue(),
                nombre_barras_agregar:this.fila_seleccionada[0].nombre,
                andina:this.andina,
            }

            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                datos2.cantidad_imprimir=this.getField('cantidad_imprimir').getValue();
            }else{
                //imprimir 1
                datos2.cantidad_imprimir=this.getField('cantidad_imprimir').getValue();
                if(this.andina!=='S'){
                    datos2.la_cantidad=this.getField('la_cantidad').getValue();
                }else{
                    datos2.fecha_vencimiento=this.getField('fecha_vencimiento').getValue();
                    datos2.fecha_fabricacion=this.getField('fecha_fabricacion').getValue();
                    datos2.lote=this.getField('lote').getValue();
                }
            }
        }else{

            datos2 = {
                sucursal_ingreso: this.sucursal_ingreso,
                cantidad_imprimir: this.cantidad_imprimir,
                select_impresora: this.getField('select_impresora').getValue(),
                codigo_articulo: this.getField('codigo_articulo').getValue(),
                nombre_articulo:this.getField('nombre_articulo').getValue(),
                barras:this.fila_seleccionada[0].barras,
                alias:this.getField('alias').getValue(),
                nombre_barras_agregar:this.fila_seleccionada[0].nombre,
                andina:this.andina,
            }
            datos2.cantidad_imprimir=this.getField('cantidad_imprimir').getValue();
            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                //zebra
                datos2.la_cantidad=this.getField('la_cantidad').getValue();
            }else{
                //imprimir2
                datos2.la_cantidad=this.getField('la_cantidad').getValue();
                datos2.fecha_vencimiento=this.getField('fecha_vencimiento').getValue();
                datos2.fecha_fabricacion=this.getField('fecha_fabricacion').getValue();
            }

        }

        this.getField('modal_stickers').handleClose();


        const myJSON = JSON.stringify(datos2);
        let datos = '?body={"datos":' + myJSON + ',"generales":{"tipo_servicio":"inve-asignarbarrasrelacionadas","operacion":"' + this.servicio + '","operacion_tipo":"consulta"}}';
        fetch(url + datos, {
            method: 'GET',
            headers: new Headers({
                "Authorization": 'Bearer ' + localStorage.getItem('token'),
                "Content-Type": 'application/json'
            })
        })
            .then(response => {
                this.getField('confirmModalCustom').toggle(false);
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if (blob.size > 0) {
                    blob.text().then(res => {
                        if (this.isJson(res)) {
                            this.successManejarRespuesta(JSON.parse(res));
                        } else {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            this.nombre_archivo=this.traerNomreArchivo();
                            a.download = this.nombre_archivo + '.txt';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        }
                    });
                } else {
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true, err, 'error');
            });
    }

    arreglarDecimales(numero){
        let numero_valor=Number(numero);
        let decimales=numero_valor.toString().split('.')[1];
        if(decimales!==undefined && decimales.length>2){
            numero_valor=numero_valor.toFixed(this.numero_decimales_compras);
        }
        return numero_valor;
    }

    successManejarRespuesta(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            //nada
        }else{
            //this.mostrarMensajeEmailFallo();
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerNomreArchivo(){
        if(this.servicio==='imprimir'){
            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                return 'LPT1_zebra-zm400';
            }else{
                let nombre='barras_relacionadas'
                this.puertos.forEach((element)=>{
                  if(element.categoria===this.getField('select_impresora').getValue()){
                    nombre=element.valor+'_'+element.categoria;
                  }
                });
                return nombre;
            }
        }else{
            //imprimir 2
            if(this.getField('select_impresora').getValue()==='zebra-zm400'){
                return 'LPT1_zebra-zm400';
            }else{
                let nombre='barras_relacionadas'
                this.puertos.forEach((element)=>{
                    if(element.categoria==='zebra'){
                    nombre=element.valor+'_'+element.categoria;
                    }
                });
                return nombre;
            }
        }
    }

}
FormJaivana.addController("inve-asignarbarrasrelacionadas", CustomAsignarBarrasRelacionadas);
export default CustomAsignarBarrasRelacionadas